import { Controller } from "stimulus";

export default class PollInteractionController extends Controller {
  connect() {
    this.inFlight = false;
    this.previousMarkup = null;
    this.previousVotedOptionId = null;
  }

  handle(event) {
    const form = event.target.closest("form");

    if (!form) return;

    const optionInput = form.querySelector(
      'input[name="community_poll_vote[community_poll_option_id]"]'
    );

    // Non-vote forms (e.g. creator/admin result toggle) should submit normally.
    if (!optionInput) return;

    // Prevent the thread card <a> from navigating when interacting with poll UI.
    event.preventDefault();
    event.stopPropagation();

    if (this.inFlight) return;
    const selectedOptionId = Number(optionInput?.value);

    if (!Number.isFinite(selectedOptionId)) return;

    this.inFlight = true;
    this.previousMarkup = this.element.innerHTML;
    this.previousVotedOptionId = this.votedOptionIdValue;

    this.disableButtons();
    this.optimisticallyUpdateResults(selectedOptionId);

    form.requestSubmit();
  }

  submitStart(event) {
    event.stopPropagation();
  }

  submitEnd(event) {
    event.stopPropagation();

    const success = event.detail?.success;

    if (success === false) {
      this.rollback();
      return;
    }

    this.inFlight = false;
    this.previousMarkup = null;
    this.previousVotedOptionId = null;
    this.enableButtons();
  }

  rollback() {
    if (this.previousMarkup != null) {
      this.element.innerHTML = this.previousMarkup;
    }

    this.votedOptionIdValue = this.previousVotedOptionId;
    this.inFlight = false;
    this.previousMarkup = null;
    this.previousVotedOptionId = null;
    this.enableButtons();
  }

  disableButtons() {
    this.element
      .querySelectorAll('button[type="submit"]')
      .forEach((button) => {
        button.disabled = true;
      });
  }

  enableButtons() {
    this.element
      .querySelectorAll('button[type="submit"]')
      .forEach((button) => {
        button.disabled = false;
      });
  }

  optimisticallyUpdateResults(selectedOptionId) {
    const barEls = this.element.querySelectorAll("[data-poll-bar]");
    const pctEls = this.element.querySelectorAll("[data-poll-pct]");

    if (barEls.length === 0 || pctEls.length === 0) {
      this.votedOptionIdValue = selectedOptionId;
      return;
    }

    const buttons = Array.from(
      this.element.querySelectorAll('button[type="submit"][data-poll-option-id]')
    );

    const previousOptionId = this.votedOptionIdValue > 0 ? this.votedOptionIdValue : null;
    const countsById = new Map();

    buttons.forEach((button) => {
      const optionId = Number(button.dataset.pollOptionId);
      const votesCount = Number(button.dataset.pollVotesCount);
      countsById.set(optionId, Number.isFinite(votesCount) ? votesCount : 0);
    });

    if (previousOptionId == null) {
      countsById.set(
        selectedOptionId,
        (countsById.get(selectedOptionId) || 0) + 1
      );
    } else if (previousOptionId !== selectedOptionId) {
      countsById.set(
        previousOptionId,
        Math.max(0, (countsById.get(previousOptionId) || 0) - 1)
      );
      countsById.set(
        selectedOptionId,
        (countsById.get(selectedOptionId) || 0) + 1
      );
    }

    const totalVotes = Array.from(countsById.values()).reduce(
      (sum, count) => sum + count,
      0
    );

    buttons.forEach((button) => {
      const optionId = Number(button.dataset.pollOptionId);
      const count = countsById.get(optionId) || 0;
      const pct = totalVotes > 0 ? Math.round((count / totalVotes) * 100) : 0;

      button.dataset.pollVotesCount = String(count);

      const bar = this.element.querySelector(
        `[data-poll-bar][data-poll-option-id="${optionId}"]`
      );
      if (bar) {
        bar.style.width = `${pct}%`;
      }

      const pctEl = this.element.querySelector(
        `[data-poll-pct][data-poll-option-id="${optionId}"]`
      );
      if (pctEl) {
        pctEl.textContent = `${pct}%`;
      }
    });

    this.votedOptionIdValue = selectedOptionId;
  }
}

PollInteractionController.values = {
  votedOptionId: Number,
};
